import { getOfficeByInternalId, isLocal } from '../../../utils';
import { ConsumerSourceType } from '../../../models';

export const formItems = {
    reason: 'reason',
    gender: 'gender',
    name: 'name',
    addition: 'tussenvoegsel',
    lastname: 'lastname',
    phoneNumber: 'phoneNumber',
    email: 'email',
    zipcode: 'zipcode',
    housenumber: 'housenumber',
    streetname: 'streetname',
    city: 'city',
    office: 'office',
    remarks: 'remarks',
};

export const transformDataForAPI = (values: any, source: ConsumerSourceType) => {
    const data = {
        Token: 'aaabbbccaabbaabbaabbcccccccccccc',
        ServiceRequestType: 'AFSPRAAKVERZOEK',
        Source: `${source}Overwaarde`,
        //Source: `${source}`,
        Comments: values[formItems.remarks],
        OfficeId: (isLocal()) ? "1100" : getOfficeByInternalId(values[formItems.office]),
        SavePhoneNumber: false,
        TelephoneNumber: values[formItems.phoneNumber],
        AddressPostalCode: values[formItems.zipcode],
        AddressHousenumber: values[formItems.housenumber],
        Email: values[formItems.email],
        Infix: values[formItems.addition],
        Initials: values[formItems.name],
        LastName: values[formItems.lastname],
        Gender: values[formItems.gender],
        ReasonForAppointment: values[formItems.reason],
        AddressStreet: values[formItems.streetname],
        AddressCity: values[formItems.city],
    };

    return data;
};
